import React from 'react';
import PropTypes from 'prop-types';
import VideoModal from '../Modal/VideoModal/VideoModal';
import { getImage } from '../../utils/attachmentUtils';
import { ViewerPrimaryColorUserStyle } from '../UserCustomization';
import act from './act.png';
import streetView from './icon-street-view.png';
import tourIconSvg from '../../shared/assets/icon-360-degrees.svg';
import svgInline from '../SvgInline/SvgInline';

export function ListMediaComponent({ type, property, onVideoClick, handleClick, marker }) {
  const imageAttachments = Array.isArray(property['attachments.images']) ? property['attachments.images'] : [];
  const videoAttachments = Array.isArray(property['attachments.videos']) ? property['attachments.videos'] : [];
  const imageObj = property.image || imageAttachments.find(i => i.sequence === '1') || {};
  const { fallback, ...image } = getImage(imageObj, type);
  image.filename = image.filename ? image.filename.trim() : undefined;
  const tour360Url = property['attachments.tourUrl'] || null;


  const addDefaultSrc = ev => {
    ev.target.src = fallback; // eslint-disable-line
  };

  // ToDo: Move Video Modal up to Wrapper. Doesn't need to exist so many times.
  return (
    <div className="list-col-1">
      <a
        tabIndex="0"
        onClick={() => handleClick(property._id)}
        className="list-media__link"
      >
        <img
          key={image.sequence}
          data-sequence={image.sequence}
          src={image.filename}
          width="90"
          height="70"
          alt={image.description}
          onError={addDefaultSrc}
        />
      </a>
      {videoAttachments.length > 0 &&
        <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
          <a
            tabIndex="0"
            onClick={() => { onVideoClick(property._id); }}
            className="list-video-link"
          >
            {`Video${videoAttachments.length > 1 ? 's' : ''}`}
          </a>
        </ViewerPrimaryColorUserStyle>
      }
      {tour360Url &&
        <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
          <a
            href={tour360Url}
            target="_blank"
            rel="noopener noreferrer"
            className="list-tour-link"
          >
            {svgInline(tourIconSvg)}
            <span>Tour</span>
          </a>
        </ViewerPrimaryColorUserStyle>
      }
      {property.actWorkReady &&
      <a
        href={property.actWorkReadyUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          className="list-media__act"
          src={act} alt="This is ACT work ready site"
        />
      </a>
      }
      {
        marker !== true &&
        <VideoModal id={property._id} urlList={videoAttachments} />
      }
      {
        property.coordinates &&
        <a href={`https://maps.google.com/maps?q=&layer=c&cbll=${property.coordinates[1]},${property.coordinates[0]}&cbp=11,0,0,0,0`} target="_blank" rel="noopener noreferrer" className="street-view">
          <img className="street-view-img" src={streetView} alt="Link to Google Street View" />
          <span>Street<br />View</span>
        </a>
      }
    </div>
  );
}

ListMediaComponent.propTypes = {
  type: PropTypes.string,
  property: PropTypes.object.isRequired,
  onVideoClick: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  marker: PropTypes.bool,
};


export default ListMediaComponent;



// WEBPACK FOOTER //
// ./src/components/List/ListMedia.js